<template>
    <div class="news-wrap">
        <div class="header-wrp">
            <Header></Header>
        </div>
        <div class="news-content-con">
            <div
                class="news-content"
                v-loading="loading"
            >
                <div class="news-title">
                    <h2>{{newsDetail.title}}</h2>
                    <div class="tip">
                        <span class="author">{{newsDetail.author}}</span>
                        <span>{{newsDetail.publishDate&&newsDetail.publishDate.slice(0,10)}}</span>
                    </div>
                </div>
                <div
                    class="news-main"
                    v-html="newsDetail.content"
                ></div>
            </div>
        </div>
    </div>
</template>

<script>
import { sdmNews } from '@service'

export default {
    name: 'newsDetail',
    data() {
        return {
            loading: false,
            newsDetail: {},
        }
    },
    mounted() {
        this.getDetail()
    },
    methods: {
        async getDetail() {
            let cntId = this.$route.params.id
            this.loading = true
            let res = await sdmNews.getSdmNewsDetail({
                cntId,
            }).catch(() => {})
            this.loading = false
            if (!res) return
            let data = res.data.data.content || {}
            this.newsDetail = data
        },
    },
}
</script>

<style lang="scss" scope>
p{
    line-height: normal;
}
.news-content-con{
    padding: 10px;
    flex: 1;
    display: flex;
}
.news-wrap{
    flex: 1;
    display: flex;
    flex-direction: column;
}
.news-content{
    max-width: 1220px;
    min-height: 600px;
    padding: 32px;
    width: 100%;
    margin: 0 auto;
    background: #fff;
    .news-title{
        border-bottom: 1px solid #EFEFEF;
        h2{
            color: #333;
            text-align: center;
            font-size: 18px;
            line-height: 20px;
            margin-bottom: 10px;
            font-weight: bold;
            padding-top: 30px;
        }
        .tip{
            text-align: right;
            font-size: 12px;
            line-height: 14px;
            color: #9197A7;
            padding: 0 8px 11px 0;
            .author{
                margin-right: 22px;
            }
        }
    }
    .news-main{
        padding-top: 40px;
    }
}
</style>
